import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const AdminLayout = ({ children }) => {
  const { logout, adminUser } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/', label: 'Tableau de bord', icon: 'bi-speedometer2' },
    { path: '/establishments', label: 'Spots', icon: 'bi-building' },
    { path: '/events', label: 'Évènements', icon: 'bi-calendar-week' },
    { path: '/recommendation-articles', label: 'Recommandations', icon: 'bi-star-fill' },
    { path: '/partner-ads', label: 'Publicités', icon: 'bi-badge-ad' },
    { path: '/categories', label: 'Catégories', icon: 'bi-tags' },
    { path: '/tags', label: 'Tags', icon: 'bi-tag' },
    { path: '/emergency', label: 'Urgences', icon: 'bi-exclamation-triangle-fill' }
  ];

  return (
    <>
      {/* Bootstrap Icons CDN */}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css" />
      
      <div className="d-flex min-vh-100">
        {/* Sidebar */}
        <div className={`bg-dark text-white ${sidebarCollapsed ? 'collapsed' : ''}`} 
             style={{ 
               width: sidebarCollapsed ? '60px' : '250px',
               transition: 'width 0.3s ease-in-out',
               position: 'fixed',
               height: '100vh',
               zIndex: 1000
             }}>
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
            {!sidebarCollapsed && <span className="fs-4">Ti'Spot Admin</span>}
            <button 
              className="btn btn-link text-white p-0" 
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            >
              <i className={`bi ${sidebarCollapsed ? 'bi-arrow-right-circle' : 'bi-arrow-left-circle'}`}></i>
            </button>
          </div>

          <ul className="nav flex-column mt-3">
            {navItems.map((item) => (
              <li className="nav-item" key={item.path}>
                <Link 
                  to={item.path}
                  className={`nav-link text-white d-flex align-items-center ${
                    location.pathname === item.path ? 'active bg-primary' : ''
                  }`}
                >
                  <i className={`bi ${item.icon} me-2`}></i>
                  {!sidebarCollapsed && <span>{item.label}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Main content */}
        <div style={{ 
          marginLeft: sidebarCollapsed ? '60px' : '250px',
          transition: 'margin-left 0.3s ease-in-out',
          width: '100%'
        }}>
          {/* Top navbar */}
          <nav className="navbar navbar-expand navbar-light bg-white shadow-sm">
            <div className="container-fluid">
              <div className="ms-auto d-flex align-items-center">
                <div className="dropdown">
                  <button 
                    className="btn btn-link text-dark dropdown-toggle text-decoration-none" 
                    type="button" 
                    data-bs-toggle="dropdown"
                  >
                    <i className="bi bi-person-circle me-2"></i>
                    {adminUser?.email}
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <button 
                        className="dropdown-item" 
                        onClick={handleLogout}
                      >
                        <i className="bi bi-box-arrow-right me-2"></i>
                        Déconnexion
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </nav>

          {/* Main content area */}
          <div className="container-fluid p-4 bg-light min-vh-100">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLayout;